import { AxiosProgressEvent } from 'axios';

import { Recaptcha } from '../recaptcha';
import { SingleToolsApi } from '../singleToolsApi';

import { IBackgroundRemoverApiOptions, IGetBgMaskOptions, IGetBgMaskResponse } from './types';

export class RemoveBackgroundApiService extends SingleToolsApi {
  constructor(options: IBackgroundRemoverApiOptions) {
    const recaptcha = new Recaptcha(options.recaptchaToken);
    super({
      baseUrl: options.baseUrl,
      getRecaptchaToken: recaptcha.getToken.bind(recaptcha),
      poolInterval: 2500,
      poolMaxTries: 24,
    });
  }

  public async getBgMask({
    images,
    setProgress,
  }: IGetBgMaskOptions): Promise<IGetBgMaskResponse[]> {
    const res = await this.post(
      '/image-bg-mask',
      {
        images,
      },
      {
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress && setProgress((prevProcess) => prevProcess + progress / 2);
        },
      },
    );

    return res.data;
  }
}
